import { render, staticRenderFns } from "./gameGold.vue?vue&type=template&id=e58420f0&scoped=true&"
import script from "./gameGold.vue?vue&type=script&lang=js&"
export * from "./gameGold.vue?vue&type=script&lang=js&"
import style0 from "./gameGold.vue?vue&type=style&index=0&id=e58420f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58420f0",
  null
  
)

export default component.exports